<template>
	<label class="label-text" :style="style" @click="clickHandler"><slot></slot></label>
</template>

<script>
	export default {
		name: 'label_',
		
		props: {
			color: {
				type: String,
				default: ''
			},
			
			size: {
				type: [String, Number]
			},
			
			bold: {
				type: Boolean,
				default: false
			},
			
			width: {
				type: [String, Number],
				default: 'auto'
			}
		},
		
		computed: {
			style(){
				const obj = {
					width: this.width == 'auto' ? 'auto' : (this.width == '100%' ? '100%' : parseFloat(this.width / 75) + 'rem'),
					fontWeight: this.bold ? 'bold' : 'normal'
				}
				this.color && Object.assign(obj, {color: this.color})
				this.size && Object.assign(obj, {fontSize: this.size == 'inherit' ? this.size : parseFloat(this.size / 75) + 'rem'})
				return obj
			}
		},
		
		methods: {
			clickHandler(){
				this.$emit('click')
			}
		}
	}
</script>

<style lang="scss" type="text/scss">
	.label-text{
		position: relative;
		display: inline;
		width: auto;
		font-size: 28px;

		&.ellipsis{
			text-align: center;
		}
	}
</style>